export default Object.freeze({
  MTH: 1,
  OnlineUpdate: 2,
  Bazar: 3,
  ParsHub: 4,
  Myket: 5,
  Cando: 6,
  IranApps: 7,
  PlayStore: 8,
  Moca: 9,
});
